import { ArquivamentoSolic } from "./ArquivamentoSolic";

export default ArquivamentoSolic;